<template>
    <v-container class="form-container">
        <page-header :title="pageTitle" :subtitle="isCreate ? null : promo.title" :back="listPath">
            <v-btn v-if="isShow" color="primary" depressed @click="goEdit">
                <v-icon left>mdi-pencil-outline</v-icon>Edit
            </v-btn>
        </page-header>

        <v-form ref="form" v-model="valid" :readonly="readOnly" @submit.prevent="onSubmit">
            <v-card outlined class="mb-4" :loading="loadingEntity">
                <v-card-text>
                    <v-text-field v-model.trim="promo.title" :rules="required" label="Title *" outlined />
                    <span class="editor-label">Content</span>
                    <editor v-model="promo.content" :api-key="tinymceApiKey" :init="editorInit" :disabled="readOnly" />
                </v-card-text>
            </v-card>

            <div v-if="!readOnly" class="form-actions">
                <v-btn text @click="goBack">Cancel</v-btn>
                <v-btn color="primary" depressed large type="submit" :loading="saving" :disabled="!valid || loadingEntity">
                    <v-icon left>mdi-content-save-outline</v-icon>{{ isCreate ? 'Create promo page' : 'Save changes' }}
                </v-btn>
            </div>
        </v-form>
    </v-container>
</template>

<script>
    import promoService from '@/services/promo-service'
    import Editor from '@tinymce/tinymce-vue'
    import formPage from '@/mixins/form-page'
    import PageHeader from '@/components/PageHeader'
    import { editorConfig, tinymceApiKey } from '@/utils/editor'

    export default {
        name: 'PromoForm',
        components: { Editor, PageHeader },
        mixins: [formPage],
        data: () => {
            return {
                entityLabel: 'Promo page',
                tinymceApiKey,
                editorInit: editorConfig({ height: 560 }),
                promoId: null,
                promo: {
                    title: '',
                    content: ''
                }
            }
        },
        created() {
            if (this.isCreate) {
                return
            }
            this.promoId = parseInt(this.$route.params.promoId)
            this.loadingEntity = true
            promoService.getPromoById(this.promoId).then(resp => {
                const promo = resp.data.data.promo[0] || {}
                this.promo = { title: promo.title || '', content: promo.content || '' }
            }).catch(error => {
                this.$notify.error(error, 'Could not load the promo page')
            }).finally(() => {
                this.loadingEntity = false
            })
        },
        methods: {
            onSubmit() {
                if (!this.validate()) {
                    return
                }
                this.saving = true
                // PromoType rejects unknown fields, so only title and content are sent
                const payload = { title: this.promo.title, content: this.promo.content }
                const request = this.isEdit
                    ? promoService.editPromoById(this.promoId, payload)
                    : promoService.createPromo(payload)
                request.then(() => {
                    this.$notify.success(this.isCreate ? 'Promo page created' : 'Promo page saved')
                    this.goBack()
                }).catch(error => {
                    this.$notify.error(error, 'Could not save the promo page')
                }).finally(() => {
                    this.saving = false
                })
            }
        }
    }
</script>
